<pr-form
  (onSubmit)="submit()"
  title="Paramétrez votre optimisation"
  [formGroup]="form"
>
  <h3>Informations du bien</h3>

  <pr-input-radio
    formControlName="propertyType"
    label="Type de bien"
    [options]="[
      { value: 'HOUSE', label: 'Maison' },
      { value: 'APPARTMENT', label: 'Appartement' },
    ]"
  >
  </pr-input-radio>

  <pr-input label="Régime fiscal actuel">
    <mat-select formControlName="fiscalityLawType">
      @for (option of fiscalityType; track option) {
        <mat-option [value]="option">{{ fiscalityLabel(option) }}</mat-option>
      }
    </mat-select>
  </pr-input>

  <pr-input label="Valeur du bien" suffix="€">
    <input formControlName="propertyValue" type="number" />
  </pr-input>

  <pr-input label="Prix d'achat" suffix="€">
    <input formControlName="purchasePrice" type="number" />
  </pr-input>

  <pr-input label="Valeur du mobilier" suffix="€">
    <input formControlName="furnitureValue" type="number" />
  </pr-input>

  <pr-input label="Montant des travaux" suffix="€">
    <input formControlName="workAmount" type="number" />
  </pr-input>

  <pr-input label="Loyer mensuel" suffix="€">
    <input formControlName="rent" type="number" />
  </pr-input>

  <h3>Financement</h3>

  <pr-input-radio
    formControlName="cashOrCredit"
    label="Investissement"
    [options]="[
      { value: 'CASH', label: 'Cash' },
      { value: 'CREDIT', label: 'Crédit' },
    ]"
  >
  </pr-input-radio>

  <pr-input
    [hidden]="inCash"
    label="Montant emprunté"
    suffix="€"
    [derrors]="derrors"
  >
    <input formControlName="borrowedAmount" type="number" />
  </pr-input>

  <pr-input
    [hidden]="inCash"
    label="Taux d'intérêt"
    suffix="%"
    [derrors]="derrors"
  >
    <input formControlName="loanInterestRate" type="number" />
  </pr-input>

  <pr-input
    [hidden]="inCash"
    label="Taux de l'assurance"
    suffix="%"
    [derrors]="derrors"
  >
    <input formControlName="loanInsuranceRate" type="number" />
  </pr-input>

  <pr-input
    [hidden]="inCash"
    label="Durée de l’emprunt"
    suffix="mois"
    [derrors]="derrors"
  >
    <input formControlName="loanDurationInMonths" type="number" />
  </pr-input>

  <pr-input-date
    [hidden]="inCash"
    formControlName="loanStartDate"
    label="Date de début d’emprunt"
    [derrors]="derrors"
  ></pr-input-date>

  <h3>Charges</h3>

  <pr-input label="Frais d'agence" suffix="€">
    <input formControlName="agencyFees" type="number" />
  </pr-input>

  <pr-input label="Frais de notaire" suffix="%">
    <input formControlName="notaryFees" type="number" />
  </pr-input>

  <pr-input label="Taxe foncière" suffix="€">
    <input formControlName="propertyTax" type="number" />
  </pr-input>

  <pr-input label="Autres charges" suffix="€">
    <input formControlName="otherFees" type="number" />
  </pr-input>
</pr-form>
